var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3702_8125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.26284 7.6725C4.13271 7.5293 4.04693 7.35142 4.01589 7.16044C3.98484 6.96946 4.00987 6.77357 4.08794 6.59652C4.16601 6.41948 4.29376 6.26889 4.45571 6.16301C4.61766 6.05713 4.80685 6.0005 5.00034 6H27.0003C27.194 6.00002 27.3836 6.05629 27.5459 6.16199C27.7082 6.26768 27.8363 6.41825 27.9147 6.59538C27.9931 6.77252 28.0183 6.96861 27.9874 7.15982C27.9564 7.35104 27.8706 7.52914 27.7403 7.6725L19.2728 16.7113C19.0993 16.8966 19.0028 17.1411 19.0028 17.395V24.3312C19.0029 24.4959 18.9624 24.6581 18.8847 24.8033C18.8071 24.9485 18.6948 25.0724 18.5578 25.1637L14.5578 27.83C14.4073 27.9311 14.2322 27.9893 14.0512 27.9985C13.8702 28.0077 13.69 27.9676 13.53 27.8823C13.3701 27.7971 13.2363 27.67 13.143 27.5145C13.0497 27.3591 13.0004 27.1813 13.0003 27V17.395C13.0004 17.1411 12.9039 16.8966 12.7303 16.7113L4.26284 7.6725Z",
    stroke: "#4A7A8A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3702_8125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.4ed9f5b822d348d9cbf33cb15be791b5.svg";
export { ForwardRef as ReactComponent };